<template>
    <div class="modal">
        <header class="modal__header">
            <h2 class="modal__heading">
                <slot name="heading" />
            </h2>
        </header>
        <div class="modal__body">
            <slot />
        </div>
        <!--/.modal__body-->
        <footer class="modal__footer">
            <slot name="footer">
                <button class="button -blue -square" @click="$emit('close')">OK</button>
            </slot>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'ModalSkeleton',
};
</script>
